<template>
    <div class="bk" :style="setBackground">
        <div class="card">
            <div class="problem">
                <div style="font-weight: bold;font-size: 16px;">举报问题</div>
                <div style="color:#999999;font-size: 14px;">
                    <icon name="warning-o" color="#999999" style="top:2px;right:2px"/>举报范围说明
                </div>
            </div>
            <div style="border-bottom-left-radius: 8px;overflow: hidden;border-bottom-right-radius: 8px;">
                <grid :column-num="2" :center="false">
                    <grid-item v-for="(item,index) in list" :key="index" @click="goAddDetail(item)">
                        <div class="grid-item">
                            <div class="grid-item-codeName">{{item.codeName}}</div>
                            <img
                                src="../image/other.png"
                                style="width: 40px;height: 40px;padding-top: 15px;"
                            />
                        </div>
                    </grid-item>
                </grid>
            </div>
            
        </div>
        
    </div>
</template>

<script>
     import {Icon,Grid, GridItem} from "vant";
     import {mapGetters} from 'vuex'

     export default {
         components: {
            Icon,Grid, GridItem
        },
        data () {
            return {
            setBackground: {
                    backgroundImage: "url(" + require("../image/bk.png") + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize:'100%' 
                    
            },
            list:this.$DICT.getList('SNAPSHOT_TYPE')
            }
        },
        comments:{
            
        },
        mounted() {
            
        },
        methods:{
            goAddDetail(item){
                this.$router.push({
                    name: 'addDetail',
                    params: item
                }) 
            }
        }
     }
</script>

<style lang="less" scoped>
    .bk {
       width: 100%;
       height: 100%;
       position: fixed;
       background-color: #F3F3F3;
    }
    .card {
        background-color: #ffffff;
        margin: 10px;
        border-radius: 8px;
        margin-top: 50%;
    }
    .problem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #eee;
    }
    .grid-item {
        background-color: #EDF4FD;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        padding:  10px 10px 5px 0;
        
    }
    .grid-item-codeName {
        color: #123D75;
        font-size: 16px;
        font-weight: bold;
        padding-left: 20px;
        border-left: 5px solid #297EFF;
        height: 20px;
    }
</style>